import {IDriver} from 'app/shared/model/driver.model';
import {IRoute} from 'app/shared/model/route.model';
import {IPatientCase} from 'app/shared/model/patient-case.model';
import {JourneyStatus} from 'app/shared/model/enumerations/journey-status.model';
import {IVillage} from 'app/shared/model/village.model';
import {IHealthcareFacility} from 'app/shared/model/healthcare-facility.model';

export interface IJourney {
  endVillage?: IVillage;
  endVillageId?: string;
  endHealthcareFacility?: IHealthcareFacility;
  endHealthcareFacilityId?: string;
  startVillage?: IVillage;
  startVillageId?: string;
  startHealthcareFacility?: IHealthcareFacility;
  startHealthcareFacilityId?: string;
  vehicleType?: any;
  vehicleTypeId?: string;
  ambulance?: any;
  ambulanceId?: string;
  payment?: any;
  id?: string;
  status?: JourneyStatus;
  incidentReportDescription?: string;
  incidentReport?: any;
  incidentReportId?: string;
  incidentReported?: boolean;
  totalCost?: number;
  totalDurationSeconds?: number;
  totalDistance?: number;
  createdAt?: string;
  driver?: IDriver;
  driverId?: string;
  route?: IRoute;
  routeId?: string;
  patientCase?: IPatientCase;
  patientCaseId?: string;
  geofenceRoute?: boolean;
}

export const defaultValue: Readonly<IJourney> = {
  incidentReported: false,
  geofenceRoute: false,
};
